<div *ngIf="ad" class='ad-card'>
  <div (click)="adClicked()" [innerHTML]="ad?.ad_text | rawHtml "></div>
</div>
